"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriftAccordion = void 0;
const react_1 = __importDefault(require("react"));
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const Accordion_1 = require("./Accordion");
const DriftAccordion = ({ header, content, showDropdown, expanded, onChange }) => (react_1.default.createElement(Accordion_1.Accordion, { disableGutters: true, expanded: expanded && showDropdown, onChange: onChange },
    react_1.default.createElement(Accordion_1.AccordionSummary, { className: showDropdown ? 'hoverEffect' : 'noHover', expandIcon: showDropdown ? react_1.default.createElement(icons_material_1.ExpandMore, null) : null },
        react_1.default.createElement(material_1.Typography, { variant: "caption", component: "div", sx: { fontSize: 16, fontWeight: 700 } }, header)),
    react_1.default.createElement(Accordion_1.AccordionDetails, null, content)));
exports.DriftAccordion = DriftAccordion;
//# sourceMappingURL=DriftAccordion.js.map